<template>
    <div class="consul-deal clearfix"
         style="height:100%;background:#f1f1f1;z-index:800;position:absolute;left:0;top:0;right:0;bottom:0;margin: auto;overflow: auto;">
        <div class="deal-content marginP " style="overflow: auto;background:#ffffff;">
            <div class="part-right consul-deal-part mypatient " style="background: #fff;margin:0;overflow: auto;">
                <div class="launch-title1" style="background: #F9F9F9;position:relative;">
                    <p v-show="platDocId!=''">{{hzysxm}} 医生相关排班</p>
                    <p v-show="platDocId==''">科室排班</p>
                    <span style="color:#92412B;position:absolute;right:20px;top:0;cursor:pointer;"
                          @click="getback">上一步</span>
                </div>
                <!--急诊加号-->
                <!--排班table切换-->
                <!--@tab-click="changeTab"-->
                <el-tabs v-model="activeName1" class="tabRow">
                    <el-tab-pane :label='hosName'/>
                </el-tabs>
                <!--排班表格-->
                <div class="docyuyue-table " style="margin-top:20px;">
                    <div class="docyuyue-left">
                        <div style="width:100%;height:52px;text-align:center;line-height:52px;box-sizing:border-box;background: #EEF1F6;border-top:1px solid #DFE6EC;border-left:1px solid #DFE6EC;border-bottom:1px solid #DFE6EC;">
                            <p style="font-size: 14px;">科室名称</p>
                        </div>
                        <div class="deptNames" v-for="item of arrangeList" style="position:relative;">
                            <div style="width:70%;height:100%;position:absolute;left:0;top:0;overflow: hidden">
                                {{ item.ksmc}}
                            </div>
                            <div style="width:30%;height:100%;line-height:50px;position:absolute;right:0;top:0;">
                                <div style="width:100%;height:50%;line-height:50px;border-left:1px solid #dfe6ec;box-sizing: border-box;border-bottom:1px solid #dfe6ec;">
                                    <p>上午</p>
                                </div>
                                <div style="width:100%;height:50%;border-left:1px solid #dfe6ec;">
                                    <p>下午</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="docyuyue-left" style="width:85%;">
                        <el-table
                                :data="allNews"
                                border
                                empty-text="没有查询到该医生的排班信息"
                                @cell-click="getCLick"
                                style="width: 100%;text-align: center;">
                            <el-table-column
                                    prop="one.mount"
                                    :label="arrDate[0]">
                                <template slot-scope="scope">
                                    <div class="ssr" style="width:100%;height:100%;cursor:pointer;"
                                         v-show="scope.row.one.mount!=''">
                                        <span style="color:red;" v-show="scope.row.one.mount=='已满'">{{scope.row.one.mount}}</span>
                                        <span style="color:red;" v-show="scope.row.one.mount=='停诊'">{{scope.row.one.mount}}</span>
                                        <span style="color:#11B6B4;"
                                              v-show="scope.row.one.mount!='已满'&&scope.row.one.mount!='停诊'">{{scope.row.one.mount}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="two.mount"
                                    :label="arrDate[1]">
                                <template slot-scope="scope">
                                    <div class="ssr" style="width:100%;height:100%;cursor:pointer;"
                                         v-show="scope.row.two.mount!=''">
                                        <span style="color:red;" v-show="scope.row.two.mount=='已满'">{{scope.row.two.mount}}</span>
                                        <span style="color:red;" v-show="scope.row.two.mount=='停诊'">{{scope.row.two.mount}}</span>
                                        <span style="color:#11B6B4;"
                                              v-show="scope.row.two.mount!='已满'&& scope.row.two.mount!='停诊'">{{scope.row.two.mount}}</span>

                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="three.mount"
                                    :label="arrDate[2]">
                                <template slot-scope="scope">
                                    <div class="ssr" style="width:100%;height:100%;cursor:pointer;"
                                         v-show="scope.row.three.mount!=''">
                                        <span style="color:red;" v-show="scope.row.three.mount=='已满'">{{scope.row.three.mount}}</span>
                                        <span style="color:red;" v-show="scope.row.three.mount=='停诊'">{{scope.row.three.mount}}</span>
                                        <span style="color:#11B6B4;"
                                              v-show="scope.row.three.mount!='已满'&& scope.row.three.mount!='停诊'">{{scope.row.three.mount}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="four.mount"
                                    :label="arrDate[3]">
                                <template slot-scope="scope">
                                    <div class="ssr" style="width:100%;height:100%;cursor:pointer;"
                                         v-show="scope.row.four.mount!=''">
                                        <span style="color:red;" v-show="scope.row.four.mount=='已满'">{{scope.row.four.mount}}</span>
                                        <span style="color:red;" v-show="scope.row.four.mount=='停诊'">{{scope.row.four.mount}}</span>
                                        <span style="color:#11B6B4;"
                                              v-show="scope.row.four.mount!='已满'&& scope.row.four.mount!='停诊'">{{scope.row.four.mount}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="five.mount"
                                    :label="arrDate[4]">
                                <template slot-scope="scope">
                                    <div class="ssr" style="width:100%;height:100%;cursor:pointer;"
                                         v-show="scope.row.five.mount!=''">
                                        <span style="color:red;" v-show="scope.row.five.mount=='已满'">{{scope.row.five.mount}}</span>
                                        <span style="color:red;" v-show="scope.row.five.mount=='停诊'">{{scope.row.five.mount}}</span>
                                        <span style="color:#11B6B4;"
                                              v-show="scope.row.five.mount!='已满'&& scope.row.five.mount!='停诊'">{{scope.row.five.mount}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="six.mount"
                                    :label="arrDate[5]">
                                <template slot-scope="scope">
                                    <div class="ssr" style="width:100%;height:100%;cursor:pointer;"
                                         v-show="scope.row.six.mount!=''">
                                        <span style="color:red;" v-show="scope.row.six.mount=='已满'">{{scope.row.six.mount}}</span>
                                        <span style="color:red;" v-show="scope.row.six.mount=='停诊'">{{scope.row.six.mount}}</span>
                                        <span style="color:#11B6B4;"
                                              v-show="scope.row.six.mount!='已满'&& scope.row.six.mount!='停诊'">{{scope.row.six.mount}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="seven.mount"
                                    :label="arrDate[6]">
                                <template slot-scope="scope">
                                    <div class="ssr" style="width:100%;height:100%;cursor:pointer;"
                                         v-show="scope.row.seven.mount!=''">
                                        <span style="color:red;" v-show="scope.row.seven.mount=='已满'">{{scope.row.seven.mount}}</span>
                                        <span style="color:red;" v-show="scope.row.seven.mount=='停诊'">{{scope.row.seven.mount}}</span>
                                        <span style="color:#11B6B4;"
                                              v-show="scope.row.seven.mount!='已满'&& scope.row.seven.mount!='停诊'">{{scope.row.seven.mount}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>

                <!--用户自主选择就诊时间-->
                <div v-show="showBox7" class="seer" style="height: 50%;">
                    <div style="width:80%;margin-left:10%;margin-top:10%;">
                        <p>就诊日期：<span style="margin-left: 30px">{{pbdata.substring(0,4)}}-{{pbdata.substring(4,6)}}-{{pbdata.substring(6,8)}}</span>
                            <span>{{ampm=="am"?"上午":"下午"}}</span></p>
                    </div>
                    <div style="width:80%;margin-left:10%;margin-top:20px;">
                        <label class="" style="color: #666666;font-size: 14px;font-weight: normal;margin-right: 30px">就诊时间</label>
                        <el-time-select
                                placeholder="选择时间"
                                :editable=false
                                format="yy-MM-dd"
                                @change="test"
                                v-model="xzsj"
                                v-show="ampm=='am'"
                                :picker-options="{
                                    start: '08:30',
                                    step: '00:15',
                                    end: '12:30'
                        }">
                        </el-time-select>
                        <el-time-select
                                placeholder="选择时间"
                                :editable=false
                                format="yy-MM-dd"
                                v-model="xzsj"
                                v-show="ampm=='pm'"
                                :picker-options="{
                                    start: '13:30',
                                    step: '00:15',
                                    end: '18:30'
                        }">
                        </el-time-select>
                    </div>
                    <div style="width:100%;position:relative;margin-top:80px;">
                        <el-button
                                type="ghost"
                                style="position:absolute;width:150px;right:50px;top:0;"
                                @click="closeBox7"
                                class="ghost-btn">返回
                        </el-button>
                        <el-button
                                type="primary"
                                @click="submitConsul"
                                class="submit-btn blue-btn h36 w200 "
                                style="position:absolute;left:50px;top:0;">
                            下一步
                        </el-button>
                    </div>
                </div>


                <!--号源弹窗-->
                <div v-show="showsBoxA"
                     style="position:absolute;left:0;right:0;top:0;bottom:0;margin:auto;width:100%;height:100%;background: #f1f1f1;z-index:890;box-sizing: border-box;padding:0px 10px 0px 10px;">
                    <div class="launch-title1" style="margin-top:10px;position:relative;">
                        <p>预约排班信息</p>
                        <p style="position:absolute;right:20px;top:0px;color:#92412B;cursor:pointer;" @click="getbacks">
                            上一步</p>
                    </div>
                    <div class="box-borders"
                         style="height:120px;background: #fff;box-sizing: border-box;padding:10px 0px;">
                        <div class="Trans-DocNews">
                            <p style="margin-top:20px;">{{hzysxm}}</p>
                            <p style="margin-top:10px;">主治医师</p>
                        </div>
                        <div class="Trans-DocNews">
                            <p style="margin-top:20px;">
                                {{pbdata.substring(0,4)}}-{{pbdata.substring(4,6)}}-{{pbdata.substring(6,8)}}</p>
                            <p style="margin-top:10px;">{{ampm=="am"?"上午":"下午"}}</p>
                        </div>
                        <div class="Trans-DocNews">
                            <p style="margin-top:20px;color:#92412B;">挂号费:{{ghf}}元</p>
                            <p style="margin-top:10px;">线下支付</p>
                        </div>
                    </div>
                    <div class="launch-title1" style="margin-top:10px;">
                        <p>选择号源时段</p>
                    </div>


                    号源列表
                    <div class="box-borders" style="background: #fff;">
                        <div style="width:80%;margin-left:10%;height:40px;position:relative;">
                            <div style="width:100%;height:2px;background:#3FC4C4;position:absolute;left:0;top:19px;"></div>
                            <div style="width:50%;z-index:801;height:100%;line-height:40px;position:absolute;left:25%;top:0;background: #fff;box-sizing: border-box;padding:0px 20px;text-align: center;">
                                <span style="color:#92412B;">{{pbdata.substring(0,4)}}-{{pbdata.substring(4,6)}}-{{pbdata.substring(6,8)}}</span>
                                <span style="color:#92412B;margin-left:20px;">{{ampm=="am"?"上午":"下午"}}</span>
                                <span style="color:#A5A5A5;margin-left:20px;">（号源时段以医院实际情况为准）</span>
                            </div>
                        </div>
                        <div style="width:90%;margin-left:5%;height:350px;overflow-y: auto;">
                            <div class="Number-unit" :class="{active13: activeName == item.index}"
                                 v-for="item of NumberList" @click="sendAll(item)">
                                <span>
                                    {{item.hyxh}}号
                                </span>
                                <span v-show="item.qhsj!=''" style="margin-left:20px;">
                                    {{item.qhsj!=""?item.qhsj:""}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <el-button type="primary"
                               class="submit-btn blue-btn h36 w200"
                               style="margin-top:30px;"
                               @click="submitConsul"
                               :loading="isSuccess">
                        下一步
                    </el-button>
                </div>
                <div v-show="showsBox"
                     style="width:100%;height:100%;position:fixed;left:0;right:0;top:0;bottom:0;margin:0 auto;background: #000;opacity: 0.3;z-index:890;">

                </div>
                <!--预约信息弹窗-->
                <div v-show="showsBtx" class="seer">
                    <div style="width:80%;height:90%;margin-left:10%;margin-top:10%;overflow: auto">
                        <p style="font-size: 16px;">预约信息</p>
                        <p style="margin-top:20px;">医院：{{hosName}}</p>
                        <p>科室: {{ksmcs}}</p>
                        <p>医生: {{platDocId==""?"普通医生":ysxm}}</p>
                        <p>就诊日期: {{pbdata.substring(0,4)}}-{{pbdata.substring(4,6)}}-{{pbdata.substring(6,8)}}</p>
                        <p>预估就诊时间: {{ampm=="am"?"上午":"下午"}} <span>{{xzsj}}</span></p>
                        <p>支付方式: 现场支付</p>
                        <p>挂号费: <span style="color:#FFD000;">{{ghf}}元</span></p>
                        <div style="height:20px;border-bottom:1px dashed #ccc;"></div>
                        <p style="font-size: 16px;">就诊人信息</p>
                        <p style="margin-top:20px;">姓名: {{yhxm}}</p>
                        <p>手机号: {{sjhm}}</p>
                        <p>身份证号: {{zjhm}}</p>
                        <p>病案号: 暂未绑定病案号</p>
                        <div style="height:20px;border-bottom:1px dashed #ccc;"></div>

                        <div style="width:100%;position:relative;margin-top:30px;">
                            <el-button
                                    type="ghost"
                                    style="position:absolute;width:150px;left:20px;top:0;"
                                    @click="showsBtxs"
                                    class="ghost-btn">取消
                            </el-button>
                            <el-button type="primary"
                                       class="submit-btn blue-btn h36 w150"
                                       style="position:absolute;right:20px;top:0;"
                                       @click="SendAllNews"
                                       :loading="isSuccess">
                                确认加号
                            </el-button>
                        </div>
                    </div>
                </div>
                <!--门诊转诊成功-->
                <div v-show="showsSucc" class="ssts1">
                    <div style="background:#ccc;width:90px;height:90px;position:absolute;left:0;right:0;top:20px;margin: 0 auto;">
                        <img src="../../../images/success.png" alt="">
                    </div>
                    <div style="margin-top:100px;width:60%;margin-left:20%;">
                        <p style="text-align: center;">加号成功</p>
                    </div>
                    <div style="margin-top:40px;width:50%;margin-left:25%;">
                        <p style="text-align: center;">{{bahms}}</p>
                        <p style="text-align: center;">{{bah}}</p>
                    </div>
                    <el-button
                            type="ghost"
                            style="position:absolute;width:150px;left:0;right:0;bottom:40px;margin:0 auto;"
                            @click="closeBoxS"
                            class="ghost-btn">我知道了
                    </el-button>
                </div>
                <!--门诊转诊失败-->
                <div v-show="showsErr" class="ssts1">
                    <div style="background:#ccc;width:90px;height:90px;position:absolute;left:0;right:0;top:20px;margin: 0 auto;">
                        <img src="../../../images/error.png" alt="">
                    </div>
                    <div style="margin-top:100px;width:60%;margin-left:20%;">
                        <p style="text-align: center;">加号失败</p>
                    </div>
                    <div style="margin-top:30px;width:70%;margin-left:15%;">
                        <p style="text-align: center;">{{bahms}}</p>
                    </div>
                    <el-button
                            type="ghost"
                            style="position:absolute;width:150px;left:0;right:0;bottom:20px;margin:0 auto;"
                            @click="closeBoxE"
                            class="ghost-btn">我知道了
                    </el-button>
                </div>
            </div>
            <div class="ssts" v-show="showBox">

            </div>
        </div>
    </div>
</template>
<style>
    .active13 {
        border: 1px solid #92412B;
        color: #92412B;
    }
</style>

<script>
  import axiosUtilz from "../../utils/AxiosUtilz.js";
  import {API_URL} from "../../data/Url";
  import {formatUnixTime} from "../../utils/DateFormat.js";

  export default {
    data() {
      return {
        docIds: "",
        bahms: "",
        consultId: "",
        showsBoxA: false,
        showsSucc: false,
        showsErr: false,
        bookSchemeId: "",
        qhsj: "",
        qhsj2: "",
        yhxm: "",
        ksmcs: "",
        showsBtx: false,
        activeName: "-1",
        hopeHosId: "",
        activeName1: "0",
        showBoxs1: false,
        zzqk: "",
        bah: "",
        showBox5: false,
        showBox4: false,
        showBox3: false,
        initDocId: "",
        initHosId: "",
        initDeptId: "",
        initDocList: [],
        initDeptList: [],
        hospListZ: [],
        ywlx: "",
        showBox2: false,
        showBox1: false,
        showBox: false,
        submits: false,
        loading: false,
        consulterIdcard: "",
        isAdviseds: false,
        sst1: "",
        showTranfer: "",
        consultStatusDescription: "",
        consultDetail: null,//会诊单详细数据
        isSuccess: false,//数据是否加载成功
        consultAdvice: "",
        evaluateData: {
          equalDiagnose: "1",//会诊前后诊断符合情况
          transfer: "0",//是否建议转诊
          medicalScore: "优",//对方病历质量评价
          recordScore: "优",//对方辅助诊断资料质量评价
          pastHistoryScore: "优",//对方病史复述能力评价
          afterDiagnose: "",//会诊后诊断
          systemScore: "优"//对方系统运行效果评价
        },
        shows6: true,
        showBox7: false,
        imgList: [],//附件图片列表
        fileList: [],//附件文件列表
        /*上传图片*/
        adviceImgList: [],// 咨询意见图片
        uploadFileCount: 0,//上传的文件数量，最大为9个
        uploadData: {},//up-load组件的data数据
        imgUploadList: [],//需上传的图片列表
        fileUploadList: [],//需上传的文件列表
        attaIdList: [],//需要提交的附件列表
        uploadUrl: API_URL,//上传图片action地址
        acceptId: "",
        isAdvised: true,

        consulterName: "",
        consulterMobile: "",
        consulterJob: "",
        hzsqyymc: "",
        hzsqksmc: "",
        hzsqysxm: "",
        consultStatus1: "",
        hzyyid: "",
        zyyymc: "",
        zyyyid: "",
        zyksmc: "",
        zyysxm: "",
        hzyymc: "",
        hzksmc: "",
        hzysxm: "",
        ysid: "",
        hzsj: "",
        hzsqyyid: "",
        hzstartTime: "",
        hzendTime: "",
        platDocId: "",
        platHosId: "",
        xzsj: "",
        arrDate: [],
        allNews: [],
        arrangeList: [],
        showsBox: false,
        ysxm: "",
        pbdata: "",
        ampm: "",
        ghf: "",
        NumberList: "",
        platDocList: [],
        consults: {},
        sjhm: "",
        zjhm: "",
        yymc: "",
        hosName: ""
      }
    },
    mounted: function () {

      this.consults = this.$route.params.showObj;
      if (this.consults.platDocList) {
        // this.platHosId=this.consults.yyid;
        // this.platDocId=this.consults.ysid;
        // this.platdeptId=this.consults.ksid;
        this.yymc = this.consults.platDocList.hosName;
      }
      this.platHosId = this.consults.yyid;
      this.platDocId = this.consults.ysid;
      this.platDeptId = this.consults.ksid;
      // this.hzysxm=this.consults.platDocList.docName;
      this.docIds = this.consults.hzid;
      this.hzysxm = this.consults.ysxm;
      this.hosName = this.consults.platDocList.hosName;
      this.yhxm = this.consults.yhxm;
      this.sjhm = this.consults.sjhm;
      this.zjhm = this.consults.zjhm;
      this.platDocList = this.consults.platDocList;
      for (var i = 0; i < this.platDocList.length; i++) {
        this.platDocList[i].index = i;
      }
      this.setDates();
      if (this.platDocId == "") {
        this.getDeptExcels();//科室排班
      } else {
        this.getDeptExcel();//医生排班
      }
      // this.getDeptExcel();
    },
    methods: {
      test: function () {
        let _this = this;
      },
      closeBoxS: function () {
        let _this = this;
        _this.showsSucc = false;
        _this.showsBox = false;
        _this.showsBoxA = false;
        _this.$router.push({name: "remoteEvaluate", params: {zzqk: _this.zzqk}});
      },
      closeBoxE: function () {
        let _this = this;
        _this.showsErr = false;
        _this.showsBox = false;
        _this.showsBoxA = false;
        _this.$router.push({name: "remoteEvaluate", params: {zzqk: _this.zzqk}});
      },
      closeBox7: function () {
        let _this = this;
        _this.showBox = false;
        _this.showBox7 = false;
        _this.xzsj = "";//返回时置空就诊时间
      },
      showsBtxs: function () {
        let _this = this;
        _this.showsBtx = false;
        _this.showsBox = false;
        _this.xzsj = "";//取消时置空就诊时间

      },
      getbacks: function () {
        this.showsBoxA = false;
      },
      getback: function () {
        let _this = this;
        _this.$router.go(-1);
      },
      setDates: function () {//获取明天开始的日期
        var dd = new Date();

        for (var i = 0; i < 7; i++) {
          this.arrDate.push(formatUnixTime(dd.setDate(dd.getDate() + 1)).substring(0, 10));
        }
      },
      getCLick: function (row, column, cell, event) {
        let _this = this;

        for (var i  in row) {
          if (i.substring(0, 3) == column.property.substring(0, 3)) {
            _this.bookSchemeId = row[i].bookSchemeId;
            _this.ysxm = row[i].ysxm;
            _this.ysid = row[i].ysid;
            _this.pbdata = row[i].data;
            _this.ampm = row[i].temp;
            _this.ghf = row[i].ghf;
            _this.ksmcs = row[i].ksmcs;
            if (row[i].mount == "停诊" || row[i].mount == "" || row[i].mount == "已满") {
              _this.showBox7 = false;
              _this.showBox = false;
            } else {
              _this.showBox7 = true;
              _this.showBox = true;
            }
            if (_this.ghf != "") {
              // _this.showsBoxA=true;
              // let options={
              //     yyid:_this.platHosId,
              //     hyrq:_this.pbdata,
              //     yylx:_this.ampm=="am"?"0":"1",
              //     yyr:JSON.parse(sessionStorage.getItem("loginInfo")).docHosId,
              //     service:"smarthos.sxzz.jhoutorder.list",
              //     pbid:_this.bookSchemeId
              // };
              // axiosUtilz(options,function(data){
              //     for(var i=0;i<data.list.length;i++){
              //         data.list[i].index=i;
              //     }
              //     _this.NumberList=data.list;
              // });

            }
          }
        }
      },
      getDeptExcel: function () {
        let _this = this;
        _this.allNews = [];
        _this.arrangeList = [];
        _this.loading = true;

        if (_this.platDocId == undefined || _this.platHosId == undefined) {
          Message({
            message: "未查询到该医生的排班信息",
            type: "warning"
          });
          return
        }
        let options = {
          service: "smarthos.sxzz.docscheme.info",
          yyid: _this.platHosId,
          ysid: _this.platDocId
          // ysid:"66912",
          // yyid:"058202"
        };
        axiosUtilz(options, function (data) {
          _this.loading = false;
          _this.arrangeList = data.list;
          for (var i = 0; i < _this.arrangeList.length; i++) {//构建基础数组
            _this.unitListAm =
              {
                one: {
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[0].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                two: {
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[1].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                three: {
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[2].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                four: {
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[3].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                five: {
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[4].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                six: {
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[5].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                seven: {
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[6].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
              }
            for (var j = 0; j < _this.arrangeList[i].pb.length; j++) {
              for (var h in _this.unitListAm) {
                _this.unitListAm[h].ysxm = _this.arrangeList[i].ysxm;
                if (_this.arrangeList[i].pb[j].hyrq == _this.unitListAm[h].data) {
                  _this.unitListAm[h].mount = _this.arrangeList[i].pb[j].swsyhy;
                  _this.unitListAm[h].bookSchemeId = _this.arrangeList[i].pb[j].pbid;
                  _this.unitListAm[h].ghf = _this.arrangeList[i].pb[j].ghf;
                  _this.unitListAm[h].ksmcs = _this.arrangeList[i].ksmc;
                }
              }
            }
            _this.allNews.push(_this.unitListAm);
            _this.unitListPm =
              {
                one: {
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[0].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                two: {
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[1].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                three: {
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[2].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                four: {
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[3].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                five: {
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[4].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                six: {
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[5].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                seven: {
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[6].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
              };
            for (var j = 0; j < _this.arrangeList[i].pb.length; j++) {
              for (var h in _this.unitListPm) {
                if (_this.arrangeList[i].pb[j].hyrq == _this.unitListPm[h].data) {
                  _this.unitListPm[h].mount = _this.arrangeList[i].pb[j].xwsyhy;
                  _this.unitListPm[h].bookSchemeId = _this.arrangeList[i].pb[j].pmpbid;
                  _this.unitListPm[h].ghf = _this.arrangeList[i].pb[j].ghf;
                  _this.unitListPm[h].ksmcs = _this.arrangeList[i].ksmc;
                }
              }
            }
            _this.allNews.push(_this.unitListPm);
          }
        });
      },
      getDeptExcels: function () {//获取科室排班
        let _this = this;
        _this.allNews = [];
        _this.arrangeList = [];
        let options = {
          service: "smarthos.sxzz.outscheme.list",//科室排班
          yyid: _this.platHosId,
          ksid: _this.platDeptId
        };
        axiosUtilz(options, function (data) {
          _this.arrangeList = data.list;
          for (var i = 0; i < _this.arrangeList.length; i++) {//构建基础数组
            _this.unitListAm =
              {
                one: {
                  ysid: "",
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[0].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                two: {
                  ysid: "",
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[1].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                three: {
                  ysid: "",
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[2].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                four: {
                  ysid: "",
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[3].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                five: {
                  ysid: "",
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[4].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                six: {
                  ysid: "",
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[5].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                seven: {
                  ysid: "",
                  temp: "am",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[6].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
              }
            for (var j = 0; j < _this.arrangeList[i].pb.length; j++) {
              for (var h in _this.unitListAm) {
                _this.unitListAm[h].ysxm = _this.arrangeList[i].ysxm;
                _this.unitListAm[h].ysid = _this.arrangeList[i].ysid;
                if (_this.arrangeList[i].pb[j].hyrq == _this.unitListAm[h].data) {
                  _this.unitListAm[h].mount = _this.arrangeList[i].pb[j].swsyhy;
                  _this.unitListAm[h].bookSchemeId = _this.arrangeList[i].pb[j].pbid;
                  _this.unitListAm[h].ghf = _this.arrangeList[i].pb[j].ghf;
                  _this.unitListAm[h].ksmcs = _this.arrangeList[i].ksmc;
                }
              }
            }
            _this.allNews.push(_this.unitListAm);
            _this.unitListPm =
              {
                one: {
                  ysid: "",
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[0].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                two: {
                  ysid: "",
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[1].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                three: {
                  ysid: "",
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[2].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                four: {
                  ysid: "",
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[3].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                five: {
                  ysid: "",
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[4].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                six: {
                  ysid: "",
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[5].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
                seven: {
                  ysid: "",
                  temp: "pm",
                  ysxm: "",
                  ghf: "",
                  data: _this.arrDate[6].replace(/-/g, ""),
                  mount: "",
                  bookSchemeId: "",
                  bookSchemeId: "",
                  ksmcs: _this.arrangeList[i].ksmc
                },
              };
            for (var j = 0; j < _this.arrangeList[i].pb.length; j++) {
              for (var h in _this.unitListPm) {
                _this.unitListPm[h].ysxm = _this.arrangeList[i].ysxm;
                _this.unitListPm[h].ysid = _this.arrangeList[i].ysid;
                if (_this.arrangeList[i].pb[j].hyrq == _this.unitListPm[h].data) {
                  _this.unitListPm[h].mount = _this.arrangeList[i].pb[j].xwsyhy;
                  _this.unitListPm[h].bookSchemeId = _this.arrangeList[i].pb[j].pmpbid;
                  _this.unitListPm[h].ghf = _this.arrangeList[i].pb[j].ghf;
                  _this.unitListPm[h].ksmcs = _this.arrangeList[i].ksmc;
                }
              }
            }
            _this.allNews.push(_this.unitListPm);
          }
        });
      },
      sendAll: function (item) {
        let _this = this;
        _this.activeName = item.index;
        _this.qhsj = item.qhsj;
        _this.qhsj2 = item.qhsj2;
        _this.yyhyid = item.hyid;
        _this.hyxh = item.hyxh;
      },
      submitConsul: function () {
        let _this = this;
        if (_this.xzsj == "" || _this.xzsj == undefined) {
          Message({
            message: "请选择就诊时间",
            type: "warning"
          });
          return
        }
        _this.showsBox = true;
        _this.showsBtx = true;
      },
      // changeTab:function(tab){
      //     // this.platHosId=this.platDocList[tab.index].bookDocId;
      //     // this.platDocId=this.platDocList[tab.index].bookHosId;
      //     this.platHosId=this.platDocList.bookHosId;
      //     this.platDocId=this.platDocList.bookDocId;
      //     // this.yymc=this.platDocList[tab.index].bookHosName;
      //     this.yymc=this.platDocList.hosName;
      //     this.getDeptExcel();
      // },
      SendAllNews: function () {
        let _this = this;

        if (_this.platDocId == "") {
          _this.platDocId = _this.ysid;
          _this.hzysxm = _this.ysxm;
        }
        // _this.platDocId==""?_this.ysid:_this.platDocId;
        let options = {
          // ghf:_this.ghf,
          areaNameArr: _this.consults.areaNameArr,
          hzid: _this.consults.hzid,
          yhxm: _this.consults.yhxm,
          zjhm: _this.consults.zjhm,
          kh: _this.consults.kh,
          hy: _this.consults.hy,
          sjhm: _this.consults.sjhm,
          lxdz: _this.consults.lxdz,
          zy: _this.consults.zy,

          sqyyid: _this.consults.sqyyid,
          sqyymc: _this.consults.sqyymc,
          sqysxm: _this.consults.sqysxm,
          sqksmc: _this.consults.sqksmc,

          zxyj: _this.consults.zxyj,
          zd: _this.consults.zd,
          zs: _this.consults.zs,
          ysid: _this.platDocId,//
          sqysid: _this.consults.sqysid,

          yymc: _this.yymc,
          yyid: _this.platHosId,//this.platHosId
          ksid: _this.platDeptId,
          ksmc: _this.ksmcs,
          ysxm: _this.hzysxm,

          hzsj: _this.consults.hzsj,
          cbzd: _this.consults.cbzd,
          tpwjdzs: _this.consults.tpwjdzs,
          fjwjdzs: _this.consults.fjwjdzs,

          pbid: _this.bookSchemeId,
          yylx: _this.ampm == "am" ? "0" : "1",
          hyid: _this.yyhyid,
          yyrq: _this.pbdata,
          jzsj: _this.xzsj,
          // jzsj2:_this.qhsj2,
          yyxh: _this.hyxh,
          zlf: _this.ghf,
          service: "smarthos.sxzz.hzmzzzsq.info"
        }
        axiosUtilz(options, function (data) {
          if (data.code == "1" || data.code == "2") {
            _this.showsBtx = false;
            _this.showsBox = true;
            _this.showsSucc = true;
            _this.zzqk = data.obj.zzqk;
            _this.bahms = data.obj.bahms;
          } else if (data.code == "3") {
            _this.showsBtx = false;
            _this.showsBox = true;
            _this.showsErr = true;
            _this.zzqk = data.obj.zzqk;
            _this.bahms = data.obj.bahms;
          }
        }, function (err) {

        })
      }
    }
  }
</script>
